import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styles from "./Navigation.module.css";
import {
  emailsList,
  emailModulesList,
  emailTemplatesList,
} from "../../actions";

export class Navigation extends Component {
  constructor(props) {
    super(props);
    this.renderNavItem = this.renderNavItem.bind(this);
    this.renderClientOption = this.renderClientOption.bind(this);
    this.setClientKey = this.setClientKey.bind(this);
  }

  setClientKey(event) {
    const accountId = event.currentTarget.value;

    const currentPath = window.location.pathname;

    if (currentPath.indexOf("/clients/") > -1) {
      window.location = window.location.pathname
        .replace(/clients\/[^/]*/, "clients/" + accountId) // Switch client key
        .replace(/(\/[^/]*\/[^/]*\/[^/]*).*/, "$1"); // Only keep first 3 url parts
    } else {
      window.location = "/clients/" + accountId;
    }
  }

  renderNavItem(link, index) {
    const {
      location: { pathname },
    } = this.props;
    const className =
      styles.navItem +
      (pathname.indexOf(link.href) === 0 ? " " + styles.active : "");

    return (
      <Link to={link.href} key={index} className={className}>
        {link.label}
      </Link>
    );
  }

  renderUserNav(user) {
    return (
      <a
        href={`${process.env.REACT_APP_API_ENDPOINT}/access/logout`}
        className={styles.navItem}
      >
        Log out {user}
      </a>
    );
  }

  renderClientOption(client) {
    return (
      <option value={client.id} key={client.id}>
        {client.name}
      </option>
    );
  }

  render() {
    const { clients, user, accountId } = this.props;

    const clientSelect =
      accountId && clients.length > 1 ? (
        <select
          className={styles.clientSelect}
          onChange={this.setClientKey}
          value={accountId}
        >
          {clients.map(this.renderClientOption)}
        </select>
      ) : null;

    const navItems = accountId
      ? [
          {
            label: "Campaigns",
            href: `/clients/${accountId}/campaigns`,
          },
          {
            label: "Modules",
            href: `/clients/${accountId}/email-modules`,
          },
          {
            label: "Templates",
            href: `/clients/${accountId}/email-templates`,
          },
          {
            label: "Images",
            href: `/clients/${accountId}/images`,
          },
        ]
      : [];

    const rootUrl = accountId ? "/clients/" + accountId : "/";

    const client = clients.find((client) => client.id === accountId);

    const navColor = client && client.color ? client.color : "#607d8b";

    document.body.style.setProperty("--main-bg-color", navColor);

    return (
      <div className={styles.navbar}>
        <Link to={rootUrl} className={styles.brand}>
          Mercury
        </Link>
        <div className={styles.nav}>{navItems.map(this.renderNavItem)}</div>

        <div className={styles.userNav}>{this.renderUserNav(user)}</div>

        {clientSelect}
      </div>
    );
  }
}

Navigation.propTypes = {
  emailTemplatesList: PropTypes.func.isRequired,
  user: PropTypes.string,
  location: PropTypes.object,
  clients: PropTypes.array,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { identity } = state.auth;
  const user = identity.name;
  const clients = identity.access || [];

  return {
    user,
    clients,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailTemplatesList,
  emailModulesList,
  emailsList,
})(Navigation);
